module.exports = __webpack_public_path__ + "img/artist_top_image.313d76e6.jpeg";